import * as React from 'react';
import * as Errors from './errors';
import { GenericErrorPage } from './generic-error-page';
import { NotFound } from './not-found';
import { ServerError } from './server-error';

export function ErrorPanel(props: { error: Error; enableReporting?: boolean; enableTicketCreationOption?: boolean }) {
  const { error, enableReporting = false, enableTicketCreationOption = false } = props;

  if (error instanceof Errors.NotFoundError) {
    return (
      <NotFound
        error={error}
        enableReporting={enableReporting}
        enableTicketCreationOption={enableTicketCreationOption}
      />
    );
  } else if (error instanceof Errors.ServerError) {
    return (
      <ServerError
        error={error}
        enableReporting={enableReporting}
        enableTicketCreationOption={enableTicketCreationOption}
      />
    );
  }

  return (
    <GenericErrorPage
      error={error}
      enableReporting={enableReporting}
      enableTicketCreationOption={enableTicketCreationOption}
    />
  );
}
